import React, { useState } from "react";
import {
  IconBox,
  PriceBox,
  NameBox,
  AnchorLink,
} from "../../../../components/molecules";
import { Title } from "../../../../components/atoms";
import viewIcon from "../../../../assets/images/view-icon.svg";
import tracIcon from "../../../../assets/images/track-icon.png";
import printIconDark from "../../../../assets/images/print-icon-dark.svg";
import printIconLight from "../../../../assets/images/print-icon.svg";
import {ReactComponent as RequestFedExIcon} from "../../../../assets/images/request-FedEx-icon.svg";

export const DeliveryOrderRow = ({
  customerName,
  orderValue,
  orderDate,
  orderRef,
  viewOnClick,
  printOnClick,
  productUrl,
  collectedOn,
  ordetTrackingID,
  isMemorabilia,
  isMemorabiliaAtStore,
  requestStorePickup,
  hasRequestedPickupAtStore,
  hasPrintedMemorabiliaLabesFromStore
}) => {

  const [isAdmin,setIsAdmin] =useState(localStorage.getItem("roleId")=="1");
console.log("oooolog", hasRequestedPickupAtStore)
  return (
    <div className="order-row d-flex w-100">
      <div className="d-flex flex-column w-100">
        <div className="d-flex gap-3 w-100 justify-content-between">
          <div className="d-flex flex-column flex-sm-row gap-2">
            <div className="space-right">
            <PriceBox topText={"Order Ref"} bottomText={orderRef} />
            </div>
            <NameBox
              name={customerName}
              heading="Customer Name"
              className={"nameBoxDelivery "}
            />
              <PriceBox
            topText={"Collected on"}
            bottomText={collectedOn || "N/A"}
          />
          </div>
          <div className="d-flex flex-column flex-sm-row gap-2">
            <PriceBox
              topText={"Order Value"}
              bottomText={`\u00A3${orderValue}`}
            />
            <div className="space-right">
              <PriceBox topText={"Order Date"} bottomText={orderDate} />
            </div>
         
              <div className="">
                <Title text={"Cricket Store"} className={"topText"} />
                <AnchorLink text={"View product"} url={productUrl} />
              </div>
          </div>
        </div>
       
      </div>
      {isAdmin && isMemorabilia && isMemorabiliaAtStore &&  <div className="align-self-start">
      <IconBox
            icon={ hasPrintedMemorabiliaLabesFromStore ? printIconLight:printIconDark}
            subtitle="Print label"
            disabled={hasPrintedMemorabiliaLabesFromStore}
            onClick={printOnClick}
            className={ "icon-box" }
          />
          <button disabled={hasRequestedPickupAtStore} className={"icon-box" } onClick={requestStorePickup}>
            {hasRequestedPickupAtStore ? <RequestFedExIcon fill="gray" /> : <RequestFedExIcon /> }
            <Title text={"Request FedEx"} className="subtitle text-nowrap" />
          </button>
        </div>}
     
      <div className="align-self-start">
     
        <IconBox icon={viewIcon} subtitle="View" onClick={viewOnClick} />
        <IconBox
          icon={tracIcon}
          subtitle="Track"
          onClick={() => {
            window.open(
              `https://www.fedex.com/fedextrack/?tracknumbers=${ordetTrackingID}`,
              "_blank"
            );
          }}
        />
      </div>
    </div>
  );
};
